import React from 'react';

function Privacy() {
  return (
    <div className="py-20 px-6 bg-background min-h-screen">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-black text-primary mb-6">Privacy Policy</h1>
          <p className="text-slate-600">Last updated: December 2024</p>
        </div>

        <div className="bg-white p-12 rounded-2xl shadow-sm border border-slate-200 prose prose-slate max-w-none">
          <h2 className="text-2xl font-bold text-primary mb-4">1. Information We Collect</h2>

          <h3 className="text-xl font-bold mb-2">Account Information</h3>
          <p className="text-slate-600 mb-4">
            When you create an account, we collect:
          </p>
          <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
            <li>Email address</li>
            <li>Name (if provided via Google Sign-In)</li>
            <li>Profile information (if provided via Google Sign-In)</li>
          </ul>

          <h3 className="text-xl font-bold mb-2">Business Data</h3>
          <p className="text-slate-600 mb-4">
            Content you create using the Service:
          </p>
          <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
            <li>Client names and email addresses</li>
            <li>Job descriptions and details</li>
            <li>Change order information (line items, costs, descriptions)</li>
            <li>Digital signatures</li>
            <li>PDF documents generated by the Service</li>
          </ul>

          <h3 className="text-xl font-bold mb-2">Usage Information</h3>
          <p className="text-slate-600 mb-6">
            We automatically collect information about how you use the Service, including device information, IP address, and usage patterns.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">2. How We Use Your Information</h2>
          <p className="text-slate-600 mb-4">
            We use your information to:
          </p>
          <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
            <li>Provide and maintain the Service</li>
            <li>Process your subscriptions and payments</li>
            <li>Send change orders and PDFs to your clients</li>
            <li>Provide customer support</li>
            <li>Improve and develop new features</li>
            <li>Send important updates about the Service</li>
            <li>Comply with legal obligations</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mb-4">3. Information Sharing</h2>
          <p className="text-slate-600 mb-4">
            We do not sell your personal information. We may share your information with:
          </p>
          <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
            <li><strong>Your clients:</strong> When you send them change orders via email</li>
            <li><strong>Service providers:</strong> Third-party services that help us operate (email delivery, payment processing, hosting)</li>
            <li><strong>Legal requirements:</strong> When required by law or to protect our rights</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mb-4">4. Data Security</h2>
          <p className="text-slate-600 mb-6">
            We implement industry-standard security measures to protect your data, including encryption, secure servers, and access controls. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">5. Data Retention</h2>
          <p className="text-slate-600 mb-6">
            We retain your information for as long as your account is active or as needed to provide the Service. You may request deletion of your account and data at any time from the Settings screen. We recommend exporting your data before deletion.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">6. Your Rights</h2>
          <p className="text-slate-600 mb-4">
            You have the right to:
          </p>
          <ul className="list-disc list-inside text-slate-600 mb-6 space-y-2">
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your account and data</li>
            <li>Export your data in CSV format</li>
            <li>Opt out of marketing communications</li>
          </ul>

          <h2 className="text-2xl font-bold text-primary mb-4">7. Third-Party Services</h2>
          <p className="text-slate-600 mb-6">
            The Service integrates with third-party services including Google Sign-In and payment processors. These services have their own privacy policies, and we encourage you to review them.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">8. Children's Privacy</h2>
          <p className="text-slate-600 mb-6">
            The Service is not intended for users under the age of 18. We do not knowingly collect information from children. If you believe we have collected information from a child, please contact us immediately.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">9. International Users</h2>
          <p className="text-slate-600 mb-6">
            If you are accessing the Service from outside the United States, please be aware that your information may be transferred to, stored, and processed in the United States where our servers are located.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">10. Changes to This Policy</h2>
          <p className="text-slate-600 mb-6">
            We may update this Privacy Policy from time to time. We will notify you of significant changes via email or through the Service. Your continued use of the Service after changes constitutes acceptance of the updated policy.
          </p>

          <h2 className="text-2xl font-bold text-primary mb-4">11. Contact Us</h2>
          <p className="text-slate-600">
            For questions about this Privacy Policy or to exercise your privacy rights, please contact us at{' '}
            <a href="mailto:privacy@scopeorder.com" className="text-secondary hover:underline">privacy@scopeorder.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
